import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { articlePicker_helper } from "../../modules/articlePicker_helper";
import { articlePicker_template } from "./articlePicker_template";
import { imageWidget_template } from "./imageWidget_template";
import { tagPicker_template } from "./tagPicker_template";

declare let ko: any;

export default class sensAI_vault_template extends vnTemplate {

    public imagePickerHelper: imagePickerHelper;
    public imagePicker: imagePicker_template;
    public imageWidgetForDefaultBrandTagImage: imageWidget_template;
    public articlePicker: articlePicker_template;
    public articlePickerHelper: articlePicker_helper;
    public tagPicker: tagPicker_template;

    protected buildViewModel() {
        let self = this;

        return {
            summaryReturned: ko.observable(false),
            similarArticlesReturned: ko.observable(false),
            systemPrompt: ko.observable(""),
            articleText: ko.observable(""),
            userQuery: ko.observable(""),
            temperature: ko.observable(0.5),
            summary: ko.observable(""),
            articles: ko.observable(""),
            imagePickerTarget: ko.observable(null),
            chatHistory: ko.observableArray([]),
            sessionId: ko.observable(""),
            isChatDisabled: ko.observable(false),
            valnetImageData: ko.observable([]),
            //idVignette: this.tagPicker.tagEdit.getTemplateViewModel().idVignette,
            onClickQuickPrompt: function (data, event) {
                self.onClickQuickPrompt(data, event);
            },
            onClickSummarize: function (data, event) {
                self.onClickSummarize(data, event);
            },
            onClickSimilarArticles: function (data, event) {
                self.initiateSensaiChat(null);
                this.hideHistoryTitle();
                const textarea = document.querySelector('.sensai-vault-user-query textarea') as HTMLTextAreaElement;
                if (textarea) {
                    textarea.style.height = "auto";
                }
                // Add the 'clicked' class to the container
                const container = document.querySelector('.sensai-vault-user-query-container');
                if (container) {
                    container.classList.add('clicked');
                }
            },
            onEnterKey: function (data, event) {
                if (event.keyCode === 13 && !event.shiftKey) {
                    self.initiateSensaiChat(event.target.value);
                    event.target.value = "";
                    this.hideHistoryTitle();
                    event.target.style.height = "auto";
                    // Add the 'clicked' class to the container
                    const container = document.querySelector('.sensai-vault-user-query-container');
                    if (container) {
                        container.classList.add('clicked');
                    }
                    return false;
                }
                return true;
            },
            hideHistoryTitle: function () {
                const historyTitle = document.querySelector('.history-title-above');
                if (historyTitle) {
                    historyTitle.classList.add('hidden');
                } else {
                    console.error("Element with class 'history-title-above' not found.");
                }
            },
            onClickClearChatHistory: function (data, event) {
                self.clearChatHistory();
            },
            onClickImage: function (data, event) {
                self.onClickImage(data, event);
            },
            onClickNewTab: function(data, event){
                self.onClickNewTab(data, event);
            },
            showArticlePicker: function (data, event) {
                self.showArticlePicker(data, event);
            },
            showArticlePickerSensai: function (data, event) {
                self.editArticleElement(data, event);
            },
            onClickOpenArticleNewTab: function (data, event) {
                self.onClickOpenArticleNewTab(data, event);
            },
            copyPermalink: function (data, event) {
                self.copyPermalink(data, event);
            },
            onClickTag: function (data, event){
                self.onClickTag(data, event);
            },
            onClickTagOpenInNewTab: function (data, event){
                self.onClickTagOpenInNewTab(data, event);
            }


        };
    }

    protected initPartial() {

        this.imagePicker = new imagePicker_template("imagePicker",this.getTemplateViewModel(),this.caller);
        this.imagePickerHelper = new imagePickerHelper(this.imagePicker,this.caller.viewModel,this.caller.getVnAppZone(),this.caller);

        this.imagePicker.setMode("single-select");
        this.imagePicker.setCaller(this.imagePickerHelper);

        this.articlePicker =  new articlePicker_template("articlePicker", this.getTemplateViewModel(), this.caller);
        this.articlePickerHelper = new articlePicker_helper(this.articlePicker, this.caller.getVnAppZone(), this.caller);
        this.articlePicker.setIsHyperLinkModeEnabled(true);
        this.articlePicker.setCaller(this.articlePickerHelper);

        this.tagPicker = new tagPicker_template("tagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setIsSingle(true);
        this.tagPicker.setParent(this);
    }

    protected getTemplateName(): string {
        return "sensAI_vault_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large", "form-create-tag"];
    }

    protected getTemplateHtml(): string {
        return /*html*/ `
            <style>
              .hidden {
                    display: none;
                }
            </style>
            <div id="sensAI_vault">
                <div class="form-body sensai-vault-form-body">
                    <h2 class="sensai-title">
                        <span class="sens">Sens</span><span class="ai">AI</span>
                    </h2>

                    <div class="form-group seo-description sensai-vault-form-body">

                        <div class="history" id="history" data-bind="foreach: chatHistory">
                            <!-- ko if: ($data.role === 'user') -->
                                <div data-bind="text: $data.content, class: $data.role"></div>
                            <!-- /ko -->
                            <!-- ko if: ($data.role === 'system') -->
                                <div data-bind="html: $data.content, class: $data.role"></div>
                            <!-- /ko -->
                        </div>
                        <h3 class="history-title-above">How can I support you?</h3>
                        <div class="sensai-vault-user-query-container" id="user-query-container" style="display: grid;">
                            <div class="sensai-vault-user-query-wrapper">
                                <div class="sensai-vault-user-query">
                                    <textarea oninput='this.style.height = "";this.style.height = this.scrollHeight + 3 + "px"' placeholder="Enter your prompt for SensAI" rows="3" data-bind="disable: isChatDisabled, value: userQuery, event: { keydown: onEnterKey }"></textarea>
                                </div>
                                <div class="sensai-vault-user-query-chat-container">
                                    <div class="quick-prompts">
                                        <button tooltip="Find me internal link suggestions I can include in my article." class="btn quick-prompt quick-prompt-1" data-bind="event: { click: onClickQuickPrompt.bind($data, $element.getAttribute('tooltip')) }"><span class="icon i-link"></span></button>
                                        <button tooltip="Find me articles related to the content of my article." class="btn quick-prompt quick-prompt-2" data-bind="event: { click: onClickQuickPrompt.bind($data, $element.getAttribute('tooltip')) }"><span class="icon i-playlist"></span></button>
                                        <button tooltip="Find me images related to the content of my article." class="btn quick-prompt quick-prompt-3" data-bind="event: { click: onClickQuickPrompt.bind($data, $element.getAttribute('tooltip')) }"><span class="icon i-image"></span></button>
                                        <button tooltip="Find me tags related to the content of my article." class="btn quick-prompt quick-prompt-4" data-bind="event: { click: onClickQuickPrompt.bind($data, $element.getAttribute('tooltip')) }"><span class="icon i-tag"></span></button>
                                    </div>
                                    <div class="actions-btn-container">
                                        <div class="sensai-vault-clear-chat-container">
                                            <button tooltip="Clear chat history" class="btn clear-chat-btn" type="button" data-bind="disable: isChatDisabled, event: {click: onClickClearChatHistory}"><span class="icon i-delete"></span></button>
                                        </div>
                                        <div class="sensai-vault-submit-container">
                                            <button tooltip="Submit your prompt" class="chat-send-btn" type="button" data-bind="disable: isChatDisabled, event: {click: onClickSimilarArticles}">
                                            <!--<span class="icon i-send"></span>-->
                                                <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 449 448">
                                                    <defs><style>.st0{fill:#fff;}</style></defs>
                                                    <path class="st0" d="M441,2.8c5.2,3.8,7.8,9.8,6.8,16l-64,384c-.8,4.8-3.8,8.8-8,11.2-2.2,1.2-5,2-7.8,2s-4-.5-6-1.2l-113.2-46.2-60.5,73.8c-3,3.8-7.5,5.8-12.2,5.8s-3.8-.2-5.5-1c-6.2-2.2-10.5-8.2-10.5-15v-87.2L376,80,108.8,311.2l-98.8-40.5c-5.8-2.2-9.5-7.5-10-13.8-.2-6,2.8-11.8,8-14.8L424,2.2c2.5-1.5,5.2-2.2,8-2.2s6.5,1,9,2.8Z"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sensai-vault-user-query sensai-vault-article-text">
                            <textarea placeholder="Enter an article for SensAI" rows="3" data-bind="value: articleText"></textarea>
                        </div>
                    </div>
                    <div id="generatedContent" data-bind="html: articles"></div>
                    ${this.imagePicker.getHtmlBuild()}
                    ${this.articlePicker.getHtmlBuild()}
                    ${this.tagPicker.getHtmlBuild()}
                </div>
            </div>
        `;
    }

    private onClickSummarize(data, event) {
        this.caller.summarizeArticle();
    }

    private initiateSensaiChat(query, isQuickPrompt = false) {
        if (query === null) {
            query = this.getTemplateViewModel().userQuery();
        }

        if (query!== "") {
            this.addToChatHistory(query, "user");
            this.caller.initiateSensaiChat(query, isQuickPrompt);
            this.getTemplateViewModel().userQuery("");
        }
    }

    private setUserQuery(query) {
        this.getTemplateViewModel().userQuery(query);
    }

    public addToChatHistory(historyItem, type) {
        let chatHistory = this.getTemplateViewModel().chatHistory();
        chatHistory.push({ content: historyItem, role: type});

        this.getTemplateViewModel().chatHistory();
        this.getTemplateViewModel().chatHistory(chatHistory);

        if(type === "system" ) {
            if(historyItem.includes("onClickImage")) {

                let galleryElements = document.querySelectorAll('.image-gallery');
                galleryElements.forEach(galleryElement => {
                    if (!galleryElement.querySelector('[data-bind]') || !ko.dataFor(galleryElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), galleryElement);
                    }
                });
            }else if (historyItem.includes("editArticleElement") || historyItem.includes("copyPermalink")) {
                let articleElements = document.querySelectorAll('.emaki-article-container');
                articleElements.forEach(articleElement => {
                    if (!articleElement.querySelector('[data-bind]') || !ko.dataFor(articleElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), articleElement);
                    }
                })

            }else if (historyItem.includes("emaki-displayCard tag") && historyItem.includes("onClickTag")) {
                let tagElements = document.querySelectorAll('.emaki-displayCard.tag');
                tagElements.forEach(tagElement => {
                    if (!tagElement.querySelector('[data-bind]') || !ko.dataFor(tagElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), tagElement);
                    }
                })
            }

        }
        setTimeout(() => {
            const historyContainer = document.getElementById('history');
            const lastChild = historyContainer.lastElementChild;
            if (lastChild) {
                lastChild.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }, 0);
    }

    public clearChatHistory(){
        this.getTemplateViewModel().chatHistory([]);
    }

    public onClickImage(data, event) {
        // Find the closest img element within the same parent div
        const imgElement = event.target.closest("div").querySelector("img");

        if (!imgElement) {
            console.error("No image found in the clicked section.");
            return;
        }

        const imageId = imgElement.id;
        this.caller.getValnetImageData(imageId);

    }


    public showImagePicker(mode, target, selectedImages = [], keyword = null) {

        let targetName = target;
        if (target && target.editor) {
            targetName = target.editor;
        }

        this.imagePicker.setIsImageOptimizable(false);
        this.imagePicker.setMode(mode);
        this.setImagePickerTarget(target);
        this.imagePicker.setTarget(targetName);
        this.imagePicker.setSelectedImages(selectedImages);
        this.caller.getImageData(keyword);
        if(mode == "multi-select"){
            this.caller.getImagesInContent(target);
        }
        this.imagePicker.show();
    }

    public setImagePickerTarget(imagePickerTarget)
    {
        this.getTemplateViewModel().imagePickerTarget(imagePickerTarget);
    }

    public onClickNewTab(data, event) {
        //data.url = data.url.replace("https://", "");
        const imgElement = event.target.closest("div").querySelector("img"); // Find the image in the same div
        if (!imgElement) {
            console.error("No image found to open in new tab.");
            return;
        }

        const imageUrl = imgElement.src;
        let cleanUrl = imageUrl.split('?')[0];
        window.open(cleanUrl, "_blank");
    }

    private onClickQuickPrompt(data, event) {
        //Clear chat history
        this.initiateSensaiChat(data, true);
        this.getTemplateViewModel().hideHistoryTitle();
        const textarea = document.querySelector('.sensai-vault-user-query textarea') as HTMLTextAreaElement;
        if (textarea) {
            textarea.style.height = "auto";
        }
        // Add the 'clicked' class to the container
        const container = document.querySelector('.sensai-vault-user-query-container');
        if (container) {
            container.classList.add('clicked');
        }
    }

    public showArticlePicker(target, selectedText = null){
        this.articlePicker.setBrand(20);
        this.articlePicker.showArticlePicker(target, null);

    }

    public editArticleElement(data, event){
        this.articlePicker.setBrand(20);
        const articleId = event.target.closest("button").getAttribute("data-id");
        const articleElement = document.querySelector(`.emaki-article-card[data-id='${articleId}']`);
        this.articlePicker.showArticlePickerView(articleElement, articleElement);
        //let insertedItems = this.caller.getArticleInsertedItems(articleElement);
    }

    public onClickOpenArticleNewTab(data, event) {
        const articleElement = event.target.closest(".emaki-article-container").querySelector(".emaki-article-card");

        if (!articleElement) {
            console.error("No article element found.");
            return;
        }

        const articleUrl = articleElement.getAttribute("data-permalink");

        if (!articleUrl) {
            console.error("No valid permalink found.");
            return;
        }

        window.open(articleUrl, "_blank");
    }

    public copyPermalink(data, event) {
        const articleElement = event.target.closest(".emaki-article-container").querySelector(".emaki-article-card");

        if (!articleElement) {
            console.error("No article element found.");
            return;
        }

        const permalink = articleElement.getAttribute("data-permalink");

        if (!permalink) {
            console.error("No permalink found.");
            return;
        }

        // Create a temporary input field for copying
        const tempInput = document.createElement("textarea");
        tempInput.value = permalink;
        document.body.appendChild(tempInput);

        // Select and copy the text
        tempInput.select();
        document.execCommand("copy");

        // Remove the temporary input field
        document.body.removeChild(tempInput);
    }

    public onClickTag(data, event){

        this.onClickPinnedTagEdit(data,event);
    }

    public showTagPicker(mode, target) {

        this.tagPicker.setMode(mode);
        this.caller.initializeCkEditors();
        this.tagPicker.setTarget(target);
        this.tagPicker.show();
    }

    // public initTagPickerCkEditors(): void{

    //     this.tagPicker.initializeCkEditors();
    // }

    public onClickSelectPinnedTag() {
        this.caller.getTagData();
        this.showTagPicker('single-select', 'pinnedTag')
    }

    public onClickPinnedTagEdit(data,event) {

        let element = event.target.closest('.emaki-displayCard.tag');
        let objData: { id: string } = { id: ""};
        // reorder specs..
        let tagInsertedFields  = this.getTagElementInsertedFieldsInOrder(element);
        this.setTagGroupTagElements([tagInsertedFields]);
        if (element) {
            let tagId = element.getAttribute('data-id'); // Get the data-id attribute
            objData.id = tagId;
        }
        this.caller.getTagData();
        this.showTagPicker('single-select', 'pinnedTag');
        this.tagPicker.editTagElement(element);
        this.tagPicker.getOnlickView(objData);
    }

    public setTagGroupTagElements(elements) {
        this.tagPicker.setTagGroupTagElements(elements);
    }

    public getTagElementInsertedFieldsInOrder(element) {
        return this.tagPicker.getTagElementInsertedFieldsInOrder(element);
    }

    public addTagPickerValidationClass() {

        document.body.classList.add('_tagpicker')
    }

    public removeTagPickerValidationClass() {

        document.body.classList.remove('_tagpicker')
    }

    public initTagPickerCkEditors(): void{

        this.tagPicker.initializeCkEditors();
    }

    public showLoading()
    {
        let loading = document.getElementById("tag-picker-view");
        loading!.classList.add("loading");
    }

    public removeLoading()
    {
        let loading = document.getElementById("tag-picker-view");
        loading!.classList.remove("loading");
    }

    public onClickTagOpenInNewTab(data, event){
        const tagPermalink = event.target.getAttribute("data-permalink");
        window.open("https://gamerant.com"+tagPermalink, "_blank");
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/sensAI_vault_template.ts